import BookButton from "@/components/np/BookButton";
import { site } from "@/content";

export default function FinalCta({ title = "Ta första steget mot en plan för din smärta", text = "Boka ett nybesök i Nacka eller Göteborg. Ingen remiss krävs." }) {
  return (
    <section className="section pt-0" aria-labelledby="final-cta-title">
      <div className="container-np">
        <div className="cta-card relative overflow-hidden rounded-[36px] bg-forest px-6 py-14 text-cream sm:px-14 sm:py-20">
          <div className="relative grid gap-8 lg:grid-cols-12 lg:items-end">
            <div className="lg:col-span-8">
              <h2 id="final-cta-title" className="font-serif text-4xl leading-[1.05] sm:text-5xl lg:text-6xl">{title}</h2>
              <p className="mt-5 max-w-xl text-cream/80 sm:text-lg">{text}</p>
            </div>
            <div className="flex flex-col gap-3 lg:col-span-4 lg:items-end">
              <BookButton testId="final-cta-book-button" size="lg" />
              <a href={site.phone.href} className="text-sm text-cream/80 underline decoration-cream/30 underline-offset-4 hover:text-cream" data-testid="final-cta-phone-link">
                eller ring {site.phone.display}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
